import { Component, Input } from '@angular/core';
import { AssignMiscOrder, DriverCard, Orders } from '../../interfaces';
import { DataServiceService } from '../../services/data-service.service';
import { MessageService } from 'primeng/api';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-misc-task-dialog',
  templateUrl: './misc-task-dialog.component.html',
  styleUrl: './misc-task-dialog.component.scss'
})
export class MiscTaskDialogComponent {

  constructor(private dataServiceService: DataServiceService, private messageService: MessageService) {}

  @Input() driverCards: DriverCard[] = [];
  @Input() selectedDriverDispatch: number = -1;
  @Input() selectedOrder: any = null;
  @Input() trailers: any[] = [];



  showMiscDialog: boolean = false;
  isEditMode: boolean = false;
  timeOnlyMode: boolean = false;
  editingOrder: any = null;

  miscDescription: string = '';
  miscTime: Date = new Date();


  openMiscDialog(driverId: number) {
    this.selectedDriverDispatch = driverId;
    this.isEditMode = false;
    this.timeOnlyMode = false;
    this.editingOrder = null;
    this.miscDescription = '';
    this.miscTime = new Date();
    this.showMiscDialog = true;
  }

  openEditMiscDialog(order: any, driverId: number) {
    this.selectedDriverDispatch = driverId;
    this.isEditMode = true;
    this.timeOnlyMode = false;
    this.editingOrder = order;
    this.miscDescription = order.notes || '';
    this.miscTime = this.parseScheduledTime(order.scheduled_time);
    this.showMiscDialog = true;
  }

  openEditMiscTime(order: any, driverId: number) {
    this.selectedDriverDispatch = driverId;
    this.isEditMode = true;
    this.timeOnlyMode = true;
    this.editingOrder = order;
    this.miscDescription = order.notes || '';
    this.miscTime = this.parseScheduledTime(order.scheduled_time);
    this.showMiscDialog = true;
  }

  private parseScheduledTime(scheduledTime: any): Date {
    if (!scheduledTime) return new Date();
    const central = DateTime.fromISO(scheduledTime.toString(), { zone: 'utc' }).setZone('America/Chicago');
    const result = new Date();
    result.setHours(central.hour, central.minute, 0, 0);
    return result;
  }


  saveMiscTask() {
    const dailyDispatchId = this.getDailyDispatchId(this.selectedDriverDispatch);
    if (!this.selectedDriverDispatch || !dailyDispatchId) {
      console.error('Missing required data:', { selectedDriver: this.selectedDriverDispatch, dailyDispatchId });
      return;
    }

    if (this.isEditMode && this.editingOrder) {
      this.dataServiceService.updateMiscTask(
        this.selectedDriverDispatch,
        dailyDispatchId,
        this.editingOrder.id,
        { notes: this.miscDescription, scheduled_time: this.miscTime }
      ).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Misc Task Updated',
            detail: 'Misc task has been updated successfully',
            life: 3000
          });
          this.resetAndClose();
        },
        error: (error) => {
          console.error('Error updating misc task:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update misc task',
            life: 3000
          });
        }
      });
    } else {
      const existingCount = this.driverCards.find(c => c.driver.driver_id === this.selectedDriverDispatch)?.dispatchOrders?.length ?? 0;
      const miscTask: AssignMiscOrder = {
        order_id: null,
        priority: String(existingCount + 1),
        scheduled_time: this.miscTime,
        notes: this.miscDescription,
      };

      this.dataServiceService.assignMiscTask(
        this.selectedDriverDispatch,
        dailyDispatchId,
        miscTask
      ).subscribe({
        next: () => {
          const driverCard = this.driverCards.find(card => card.driver.driver_id === this.selectedDriverDispatch);
          if (driverCard) {
            this.messageService.add({
              severity: 'success',
              summary: 'Misc Task Added',
              detail: `Misc task has been assigned to ${driverCard.driver.first_name} ${driverCard.driver.last_name}`,
              life: 3000
            });
          }
          this.resetAndClose();
        },
        error: (error) => {
          console.error('Error saving misc task:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save misc task',
            life: 3000
          });
        }
      });
    }
  }

  cancelMiscDialog(): void {
    this.resetAndClose();
  }

  private resetAndClose() {
    this.miscDescription = '';
    this.miscTime = new Date();
    this.editingOrder = null;
    this.isEditMode = false;
    this.timeOnlyMode = false;
    this.showMiscDialog = false;
  }



  private getDailyDispatchId(driverId: number): number | undefined {
    const driver = this.driverCards.find(d => d.driver.driver_id === driverId);
    return driver?.dailyDispatch?.id;
  }
}
